import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    expert: {
      type: Object,
      required: true
    }
  },
  computed: mapGetters({
    loading: 'skiliko/session/isLoading'
  }),
  methods: mapActions({
    save: 'skiliko/session/updateCurrentUser'
  })
}



// WEBPACK FOOTER //
// ./src/mixins/currentExpert.js